/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatVisaType } from '../../utils/onlineVisaUtils';
import './VisaFilters.scss';

function VisaFilters({ visaList, filters, onFilterChange }) {
  const visaTypes = useMemo(() => {
    const set = new Set();
    (visaList || []).forEach((v) => v?.visaType && set.add(v.visaType));
    return Array.from(set);
  }, [visaList]);

  const entries = useMemo(() => {
    const set = new Set();
    (visaList || []).forEach((v) => v?.entry && set.add(v.entry));
    return Array.from(set);
  }, [visaList]);

  const toggleType = (type) => {
    const next = new Set(filters.visaTypes || []);
    if (next.has(type)) next.delete(type);
    else next.add(type);
    onFilterChange({ ...filters, visaTypes: Array.from(next) });
  };

  const toggleEntry = (entry) => {
    const next = new Set(filters.entries || []);
    if (next.has(entry)) next.delete(entry);
    else next.add(entry);
    onFilterChange({ ...filters, entries: Array.from(next) });
  };

  const handleSortChange = (e) => {
    onFilterChange({ ...filters, sortBy: e.target.value });
  };

  const handleReset = () => {
    onFilterChange({ visaTypes: [], entries: [], sortBy: 'price-asc' });
  };

  return (
    <aside className="visa-filters">
      <div className="visa-filters__header">
        <h3 className="visa-filters__title">Filters</h3>
        <button
          type="button"
          className="visa-filters__reset"
          onClick={handleReset}
        >
          Clear All
        </button>
      </div>

      <div className="visa-filters__section">
        <h4>Sort by</h4>
        <select
          className="visa-filters__select"
          value={filters.sortBy || 'price-asc'}
          onChange={handleSortChange}
        >
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          <option value="processing-asc">Fastest Processing</option>
          <option value="processing-desc">Slowest Processing</option>
          <option value="stay-desc">Longest Stay</option>
          <option value="stay-asc">Shortest Stay</option>
        </select>
      </div>

      {visaTypes.length > 0 && (
        <div className="visa-filters__section">
          <h4>Visa Type</h4>
          {visaTypes.map((t) => (
            <label key={t} className="visa-filters__checkbox">
              <input
                type="checkbox"
                checked={(filters.visaTypes || []).includes(t)}
                onChange={() => toggleType(t)}
              />
              <span>{formatVisaType(t)}</span>
            </label>
          ))}
        </div>
      )}

      {entries.length > 0 && (
        <div className="visa-filters__section">
          <h4>Entry</h4>
          {entries.map((e) => (
            <label key={e} className="visa-filters__checkbox">
              <input
                type="checkbox"
                checked={(filters.entries || []).includes(e)}
                onChange={() => toggleEntry(e)}
              />
              <span>{e.charAt(0) + e.slice(1).toLowerCase()}</span>
            </label>
          ))}
        </div>
      )}
    </aside>
  );
}

VisaFilters.propTypes = {
  visaList: PropTypes.array,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func.isRequired,
};

VisaFilters.defaultProps = {
  visaList: [],
  filters: { visaTypes: [], entries: [], sortBy: 'price-asc' },
};

export default VisaFilters;
